import { Link } from 'react-router-dom';

interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  coverUrl: string;
  latestChapter: string;
  chapterTitle: string;
  rating: number;
  views: string;
  updateTime: string;
}

const featuredComics: Comic[] = [
  {
    id: 1,
    title: '深渊之花',
    author: '金秀贤',
    category: '奇幻异界',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20with%20mysterious%20dark%20floral%20theme%2C%20elegant%20female%20character%2C%20deep%20warm%20crimson%20and%20gold%20accents%2C%20clean%20composition%2C%20stylized%20webtoon%20art%2C%20soft%20dramatic%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-01&orientation=portrait',
    latestChapter: '第48话',
    chapterTitle: '深渊之门的秘密',
    rating: 9.6,
    views: '185.2万',
    updateTime: '2小时前',
  },
  {
    id: 2,
    title: '首尔之恋',
    author: '朴智恩',
    category: '浪漫爱情',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20with%20warm%20peach%20and%20pink%20tones%2C%20elegant%20couple%20in%20modern%20Seoul%20setting%2C%20clean%20composition%2C%20stylized%20webtoon%20art%2C%20soft%20romantic%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-02&orientation=portrait',
    latestChapter: '第62话',
    chapterTitle: '樱花树下的约定',
    rating: 9.4,
    views: '256.8万',
    updateTime: '5小时前',
  },
  {
    id: 3,
    title: '武神传说',
    author: '李俊昊',
    category: '热血动作',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20with%20martial%20arts%20theme%2C%20dynamic%20warrior%20character%2C%20warm%20orange%20and%20amber%20tones%2C%20dramatic%20composition%2C%20stylized%20webtoon%20art%2C%20powerful%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-03&orientation=portrait',
    latestChapter: '第125话',
    chapterTitle: '最终决战',
    rating: 9.8,
    views: '452.3万',
    updateTime: '1天前',
  },
  {
    id: 4,
    title: '暗夜追踪者',
    author: '崔敏浩',
    category: '悬疑惊悚',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20with%20noir%20detective%20theme%2C%20mysterious%20male%20character%2C%20deep%20warm%20sepia%20and%20shadow%20tones%2C%20dramatic%20composition%2C%20stylized%20webtoon%20art%2C%20cinematic%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-04&orientation=portrait',
    latestChapter: '第36话',
    chapterTitle: '真相浮现',
    rating: 9.3,
    views: '128.6万',
    updateTime: '8小时前',
  },
  {
    id: 5,
    title: '魔法学园',
    author: '郑多恩',
    category: '奇幻异界',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%20with%20magic%20academy%20theme%2C%20young%20wizard%20characters%2C%20warm%20golden%20and%20amber%20tones%2C%20enchanting%20composition%2C%20stylized%20webtoon%20art%2C%20soft%20magical%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-05&orientation=portrait',
    latestChapter: '第89话',
    chapterTitle: '学院祭的奇迹',
    rating: 9.5,
    views: '312.4万',
    updateTime: '3小时前',
  },
  {
    id: 6,
    title: '心动频率',
    author: '尹彩瑛',
    category: '浪漫爱情',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20with%20music%20and%20youth%20theme%2C%20stylish%20characters%2C%20warm%20coral%20and%20pastel%20tones%2C%20sweet%20composition%2C%20stylized%20webtoon%20art%2C%20soft%20dreamy%20lighting%2C%20minimal%20background&width=400&height=560&seq=comic-06&orientation=portrait',
    latestChapter: '第71话',
    chapterTitle: '心跳的旋律',
    rating: 9.2,
    views: '198.7万',
    updateTime: '12小时前',
  },
];

export default function FeaturedSection() {
  return (
    <section className="relative bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              本周热门更新
            </h2>
            <p className="text-lg md:text-xl font-heading font-medium text-foreground-800 mt-1">
              精选韩国漫画
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={comic.coverUrl}
                    alt={comic.title}
                    title={`韩漫在线观看 - ${comic.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {comic.rating}分
                  </div>
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-950/60 text-background-50 text-xs">
                    {comic.updateTime}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{comic.author} · {comic.category}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-accent-600 font-medium">
                      {comic.latestChapter} · {comic.chapterTitle}
                    </span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line mr-1"></i>{comic.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium hover:bg-secondary-200 transition-all whitespace-nowrap"
            >
              查看更多漫画
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}